import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Alert, Button, Checkbox, Input } from '@dreamtree-org/twreact-ui';
import { useAppApi } from '@/lib/api';
import { setAuth } from '@rbac/permissions';
import { errorMessage } from '@/lib/format';
import AuthShell from './AuthShell';

const REMEMBER_KEY = 'zorzo:remember';

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { fetchApi, loading } = useAppApi();

  const [identifier, setIdentifier] = useState(localStorage.getItem(REMEMBER_KEY) || '');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(!!localStorage.getItem(REMEMBER_KEY));
  const [err, setErr] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});

  const validate = () => {
    const errors = {};
    if (!identifier.trim()) errors.identifier = 'Enter your email or mobile number';
    if (!password) errors.password = 'Enter your password';
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (!validate()) return;
    try {
      const res = await fetchApi('login', { identifier: identifier.trim(), password });
      if (remember) localStorage.setItem(REMEMBER_KEY, identifier.trim());
      else localStorage.removeItem(REMEMBER_KEY);
      setAuth((res && res.data) || res);
      nav((loc.state && loc.state.from) || '/', { replace: true });
    } catch (ex) {
      setErr(errorMessage(ex, 'Sign-in failed'));
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Sign in to check what's expiring in your warehouse."
      footer="Accounts are created by your administrator."
    >
      {err ? (
        <div className="mb-4">
          <Alert variant="error" title="Sign-in failed" dismissible onDismiss={() => setErr('')}>
            {err}
          </Alert>
        </div>
      ) : null}

      <form onSubmit={submit} className="space-y-4" noValidate>
        <Input
          label="Email or mobile number"
          type="text"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          error={fieldErrors.identifier}
          placeholder="you@company.com"
          required
        />
        <Input
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={fieldErrors.password}
          required
        />

        <Checkbox label="Remember me" checked={remember} onChange={(e) => setRemember(e.target.checked)} />

        <Button type="submit" fullWidth loading={loading}>
          Sign in
        </Button>
      </form>
    </AuthShell>
  );
}
